import Navigation from "../../stories/Components/Navigation";
import {
    NavigationThemes,
    NavLinkProps,
} from "../../stories/Components/Navigation/interface";
import { IconColours } from "../../stories/Foundation/Icons/interface";
import { useElectionsBarData } from "./hook";
import styles from "./electionsBar.module.scss";

const ElectionsBar = () => {
    const electionsBarData = useElectionsBarData() as NavLinkProps[];

    if (!electionsBarData || electionsBarData.length === 0) {
        return null;
    }

    const navIconElement = (
        <div className={styles.navIconElement} data-testid="nav-icon">
            Canada Votes 2025
        </div>
    );

    const navigationProps = {
        links: electionsBarData,
        orientation: "horizontalNav",
        theme: NavigationThemes.BLACKANDWHITE,
        iconColour: IconColours.white,
        navIconElement,
        featureAttribution: {
            name: "swimlane",
            instance: "election-bar",
        },
    };

    return (
        <div
            className={styles.electionsBarContainer}
            data-testid="elections-bar"
        >
            <div className={styles.electionsBarNav}>
                <Navigation {...navigationProps} />
            </div>
        </div>
    );
};

export default ElectionsBar;
